export const userInfo = {
  maxWidth: 'auto',
  pictureSize: 'xs',
};
